import { clsx } from "@trydig/ui";
import styles from "./Skeleton.module.css";

interface SkeletonProps extends React.ComponentProps<"div"> {
	height?: string | number;
	width?: string | number;
	absolute?: boolean;
	fitContent?: boolean;
	as?: "div" | "span";
	spaced?: "y" | "x" | "both";
}

export const Skeleton = ({
	height,
	absolute,
	style,
	width,
	fitContent,
	children,
	className,
	as,
	spaced,
	...restProps
}: SkeletonProps) => {
	const Component = as ?? "div";
	return (
		<Component
			aria-busy="true"
			className={clsx(styles.root, className, {
				[styles.spacedY]: spaced === "y" || spaced === "both",
				[styles.spacedX]: spaced === "x" || spaced === "both",
			})}
			{...restProps}
			style={{
				...style,
				height,
				width: width,
				position: absolute ? "absolute" : "relative",
				...(fitContent && {
					width: "fit-content",
					height: "fit-content",
				}),
			}}
		>
			<span aria-hidden="true">{children}</span>
		</Component>
	);
};
